import AlertCircle from "@/assets/img/symbolic/error.svg?react";
import { motion } from "framer-motion";

export default function NotAFollower()
{
    return (
        <motion.div
            className={Wind.style({
                display: "flex",
                flexDirection: "flex-col",
                alignItems: "items-center",
                justifyContent: "justify-center",
                height: "h-full",
            }).class}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
        >
            <div
                className={Wind.style({
                    maxWidth: "max-w-[23rem]",

                }).class}
            >
                <div className="flex justify-center mb-6">
                    <div className="rounded-full p-4">
                        <AlertCircle className="h-12 w-12 text-red-500" />
                    </div>
                </div>

                {/* Error Title */}
                <h2
                    className={Wind.style({
                        fontSize: "text-2xl",
                        fontWeight: "font-semibold",
                        textAlign: "text-center",
                        color: "text-gray-900",
                        marginBottom: "mb-4",
                        textWrap: "text-balance",
                    }).class}
                >
                    You&apos;re Not Following This Profile
                </h2>

                {/* Error Description */}
                <div className="text-gray-600 mb-8 space-y-2 text-balance text-center">
                    <p>This profile has their content only visible to followers.</p>
                </div>
            </div>
        </motion.div>
    );
}
